import { useState } from 'react';
import { Icon } from '@iconify/react';
import VendorSettingLayout from './VendorSettingLayout';

const VendorSettingApprovals = () => {
    const [settings, setSettings] = useState({
        requireApprovalForBills: true,
        approvalThreshold: 10000,
    });

    const handleSettingChange = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    return (
        <VendorSettingLayout>
            <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-100 tw-p-4">
                <h2 className="tw-text-sm tw-font-semibold tw-text-gray-800 tw-mb-4">Approval Settings</h2>
                <div className="tw-space-y-4">
                    <div className="tw-flex tw-items-center tw-justify-between tw-p-4 tw-border tw-border-gray-100 tw-rounded-lg">
                        <div className="tw-flex tw-items-center tw-gap-3">
                            <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-amber-50 tw-flex tw-items-center tw-justify-center">
                                <Icon icon="mdi:check-decagram" className="tw-text-amber-600" />
                            </div>
                            <div>
                                <p className="tw-text-sm tw-font-medium tw-text-gray-700">Require Approval for Bills</p>
                                <p className="tw-text-xs tw-text-gray-500">Bills above threshold need approval before payment</p>
                            </div>
                        </div>
                        <button
                            onClick={() => handleSettingChange('requireApprovalForBills', !settings.requireApprovalForBills)}
                            className={`tw-w-12 tw-h-6 tw-rounded-full tw-transition-colors tw-relative ${settings.requireApprovalForBills ? 'tw-bg-blue-600' : 'tw-bg-gray-300'}`}
                        >
                            <span className={`tw-absolute tw-w-5 tw-h-5 tw-bg-white tw-rounded-full tw-top-0.5 tw-transition-transform ${settings.requireApprovalForBills ? 'tw-translate-x-6' : 'tw-translate-x-0.5'}`} />
                        </button>
                    </div>
                    {settings.requireApprovalForBills && (
                        <div className="tw-pl-16">
                            <label className="tw-text-xs tw-font-medium tw-text-gray-600 tw-mb-1 tw-block">Approval Threshold Amount (₹)</label>
                            <input
                                type="number"
                                value={settings.approvalThreshold}
                                onChange={(e) => handleSettingChange('approvalThreshold', parseInt(e.target.value))}
                                className="tw-w-48 tw-px-3 tw-py-2 tw-border tw-border-gray-200 tw-rounded-lg tw-text-sm focus:tw-outline-none focus:tw-border-blue-500"
                            />
                            <p className="tw-text-xs tw-text-gray-500 tw-mt-1">Bills above ₹{settings.approvalThreshold.toLocaleString('en-IN')} will require approval</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Save Button */}
            <div className="tw-flex tw-justify-end tw-mt-4">
                <button className="tw-flex tw-items-center tw-gap-2 tw-bg-blue-600 tw-text-white tw-px-6 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium hover:tw-bg-blue-700">
                    <Icon icon="mdi:content-save" />
                    Save Settings
                </button>
            </div>
        </VendorSettingLayout>
    );
};

export default VendorSettingApprovals;
